import React from "react";
import IconButton from "../common/IconButton";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function BackButton({ onBack }) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <IconButton
      onClick={onBack || goBack}
      icon={<IoMdArrowRoundBack size={35} color="silver" />}
    />
  );
}
